import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// Route to translation key mapping
const ROUTE_TO_TITLE_MAP: Record<string, string> = {
    '/': 'pages.home',
    '/about': 'pages.about',
    '/tournaments': 'pages.tournaments',
    '/privacy': 'pages.privacy',
    '/imprint': 'pages.imprint',
    '/terms': 'pages.terms',
    '/event-rules': 'pages.eventRules',
}

export const usePageTitle = () => {
    const { t, i18n } = useTranslation()
    const location = useLocation()

    useEffect(() => {
        const translationKey = ROUTE_TO_TITLE_MAP[location.pathname]
        const pageName = translationKey
            ? t(translationKey)
            : t('pages.notFound')

        document.title = `Dailyvents - ${pageName}`

        // Update HTML lang attribute
        const htmlLang = i18n.language === 'de-DE' ? 'de' : 'en'
        document.documentElement.lang = htmlLang
    }, [location.pathname, t, i18n.language])
}
